export default __webpack_public_path__ + "static/media/worthy.9f35ae50.jpg";